import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
// import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sub-item-income-report',
  templateUrl: './sub-item-income-report.component.html',
  styleUrls: ['./sub-item-income-report.component.css']
})
export class SubItemIncomeReportComponent implements OnInit {

  public menu_item_id = '35';
  
  search_customer = {
    'placeholder': 'اسم العميل/ رقم العميل/ رقم الجوال', 'class_name': 'midField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile']
    }]
  };
  search_obj = {
    'placeholder': 'اسم الصنف/ Item Name', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`main_item`', 'selected_no': 'sub_item_no',
      'field_list': ['main_item_name', 'main_item_name_en'],
      'join_table': '`sub_item`',
      'join_field_list': ['sub_item_no'],
      'join_condition': " AND `main_item`.`main_item_id` = `sub_item`.`main_item_id` AND `sub_item`.`is_sale` = '1'"
    }]
  };
  
  view_type = [{'view_value': 'sub_item', 'view_name': 'الصنف', 'view_name_en': 'Item'}, 
    {'view_value': 'item_cat', 'view_name': 'التصنيف', 'view_name_en': 'Item Category'}];

  private dp = [];
  itemCats = [];
  all_itemSubCats = [];
  itemSubCats = [];
  
  displayedColumns = ['sub_item_number', 'sub_item_name', 'sub_item_no', 'unit_name',
    'count', 'price', 'cost', 'detail', 'invoice_no', 'date', 'customer_name', 'name'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'branch_id': '', 'from_date': new Date(), 'to_date': new Date(), 'title': 'تقرير أرباح الصنف',
    'view_type': 'sub_item', 'item_cat_id': '', 'item_subcat_id': '', 'sub_item_no': '', 'customer_no': ''
  };

  total_price = '0';
  total_cost = '0';
  total_income = '0';

  Sub_Item_Income_Report; Sales; Sales_Return; Sale_Price_Total; Cost_Total;
  Income_Total; Sub_item_Placeholder; From_Date; To_Date; Customer_Placeholder;
  From_Date_Msg; To_Date_Msg; Sub_Item_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Sub_Item_Income_Report').subscribe((res: string) => {
      this.Sub_Item_Income_Report = res;
    });
    this.model['title'] = this.Sub_Item_Income_Report;

    translate.get('Sales').subscribe((res: string) => {
      this.Sales = res;
    });

    translate.get('Sales_Return').subscribe((res: string) => {
      this.Sales_Return = res;
    });

    translate.get('Sub_item_Placeholder').subscribe((res: string) => {
      this.Sub_item_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Sub_item_Placeholder;

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Sale_Price_Total').subscribe((res: string) => {
      this.Sale_Price_Total = res;
    });

    translate.get('Cost_Total').subscribe((res: string) => {
      this.Cost_Total = res;
    });

    translate.get('Income_Total').subscribe((res: string) => {
      this.Income_Total = res;
    });

    translate.get('Customer_Placeholder').subscribe((res: string) => {
      this.Customer_Placeholder = res;
    });
    this.search_customer['placeholder'] = this.Customer_Placeholder;
    
    translate.get('From_Date_Msg').subscribe((res: string) => {
      this.From_Date_Msg = res;
    });

    translate.get('To_Date_Msg').subscribe((res: string) => {
      this.To_Date_Msg = res;
    });
    
    translate.get('Sub_Item_Msg').subscribe((res: string) => {
      this.Sub_Item_Msg = res;
    });
  }

  ngOnInit() {
    let query, obj;
    query = this.queryList.all_itemCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.itemCats = data.data['list'];
      });

    query = this.queryList.all_itemSubCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.all_itemSubCats = data.data['list'];
      });

  }

  getSubCat() {
    this.itemSubCats = [];
    this.all_itemSubCats.forEach(element => {
      if (element.item_cat_id == this.model['item_cat_id'])
        this.itemSubCats.push(element);
    });
    if (this.itemSubCats.length > 0)
      this.model['item_subcat_id'] = this.itemSubCats[0]['item_subcat_id'];
  }

  onChangeSearch = function (search_result: object) {
    this.model['sub_item_no'] = search_result['no'];
  }

  onChangeCustomer = function (search_result: object) {
    this.model['customer_no'] = search_result['no'];
  }

  search() {
    this.total_price = '0';
    this.total_cost = '0';
    this.total_income = '0';
    this.dp = [];

    if (this.model['from_date'] == undefined || this.model['from_date'].toString() == '') {
      alert(this.From_Date_Msg);
      return;
    }

    if (this.model['to_date'] == undefined || this.model['to_date'].toString() == '') {
      alert(this.To_Date_Msg);
      return;
    }

    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate() + " 00:00:00";

    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate() + " 23:59:59";

    let sub_item_no = (this.model['view_type'] == 'sub_item' ? this.model['sub_item_no'] : '');
    let item_cat_id = (this.model['view_type'] == 'item_cat' ? this.model['item_cat_id'] : '');
    let item_subcat_id = (this.model['view_type'] == 'item_cat' ? this.model['item_subcat_id'] : '');

    let obj = { cmd: 'getSubItemIncome', from_date: from_date, to_date: to_date, 
      customer_no: this.model['customer_no'], sub_item_no: sub_item_no, item_cat_id: item_cat_id, 
      item_subcat_id: item_subcat_id };

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.data['list'];
        console.log(this.dp);
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

  }

  print() {
    
    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate();
    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate();

    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"><h2> ' + this.Sub_Item_Income_Report + '</h2></td></tr>';
    html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + from_date + '</td><td width="33%"> ' + this.To_Date + ': ' + to_date + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('incomes_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
